import { BaseHttpService } from '@/services/base-http-service'
import { ShipmentMethod } from '@/types'

class ShipmentMethodService extends BaseHttpService {
    async getShipmentMethods(): Promise<ShipmentMethod[]> {
        const result = await this.doApiGet<ShipmentMethod[]>('/shipment-method')
        if (result.success) {
            return result.response!
        }
        throw new Error(result.error!.message)
    }
}

export default new ShipmentMethodService()
